//overlayer appnexus
export const adSlotPrebid = {
    freewheel: {
        zoneId: {
            fanpage_video: '33905290',
            ck_it_video: '33905292',
            geopop_video: '33905308',
            ck_wow_video: '33905294',
            ohga_video: '33905312',
            kodami_video: '33905310',
            wamily_video: '33905290',
            lexplain_video: '33905314'
        }
    },
    yobee: {
        display: {
            fanpage_inarticle: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/fanpage_inarticle"
            },
            cookist_it_inarticle: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/cookist_it_inarticle"
            },
            geopop_inarticle: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_inarticle"
            },
            fpmobile_leadeboard: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/fpmobile_leadeboard"
            },
            fpmobile_300x250_top: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/fpmobile_300x250_top"
            },
            fpmobile_300x250: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/fpmobile_300x250"
            },
            fpmobile_fplayer: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/fpmobile_fplayer"
            },
            fpmobile_300x250_bottom: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/fpmobile_300x250_bottom"
            },
            ck_it_mobile_leadeboard: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_it_mobile_leadeboard"
            },
            ck_it_mobile_300x250_top: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_it_mobile_300x250_top"
            },
            ck_it_mobile_300x250: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_it_mobile_300x250"
            },
            ck_it_mobile_fplayer: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_it_mobile_fplayer"
            },
            ck_it_mobile_fplayer2: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_it_mobile_fplayer2"
            },
            ck_it_mobile_fplayer3: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_it_mobile_fplayer3"
            },
            ck_it_mobile_fplayer4: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_it_mobile_fplayer4"
            },
            ck_it_mobile_300x250_bottom: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_it_mobile_300x250_bottom"
            },
            ohga_header: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ohga_header"
            },
            ohga_300x250_top: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ohga_300x250_top"
            },
            ohga_300x250_middle: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ohga_300x250_middle"
            },
            ohga_low: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ohga_low"
            },
            ohga_bottom: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ohga_bottom"
            },
            geopop_leaderboard: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_leaderboard"
            },
            geopop_top: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_top"
            },
            geopop_middle: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_middle"
            },
            geopop_fplayer: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_fplayer"
            },
            geopop_fplayer2: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_fplayer2"
            },
            geopop_fplayer3: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_fplayer3"
            },
            geopop_fplayer4: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_fplayer4"
            },
            geopop_bottom: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_bottom"
            },
            ckmobile_leaderboard: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ckmobile_leaderboard"
            },
            ckmobile_300x250_top: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ckmobile_300x250_top"
            },
            ckmobile_300x250: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ckmobile_300x250"
            },
            ckmobile_fplayer: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ckmobile_fplayer"
            },
            ckmobile_300x250_bottom: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ckmobile_300x250_bottom"
            },
            kodami_header: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/kodami_header"
            },
            kodami_top: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/kodami_top"
            },
            kodami_middle: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/kodami_middle"
            },
            kodami_low: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/kodami_low"
            },
            kodami_bottom: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/kodami_bottom"
            }
        },
        video: {
            fanpage_video: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/fanpage_video"
            },
            ck_it_video: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_it_video"
            },
            ck_wow_video: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_wow_video"
            },
            ck_legal_video: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ck_legal_video"
            },
            ohga_video: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/ohga_video"
            },
            kodami_video: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/kodami_video"
            },
            geopop_video: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/geopop_video"
            },
            wamily_video: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/wamily_video"
            },
            lexplain_video: {
                networkId: 3481786972,
                host: "ciaopeople.rtb.yobee.it",
                gpid: "/1010633/lexplain_video"
            }
        }
    },
    appnexus: {
        code: {
            fanpage_video: 'fanpage.it_video',
            ck_it_video: 'cookist.it_video',
            ck_wow_video: 'cookist.com_video',
            ck_legal_video: 'cookist.com_video',
            ohga_video: 'ohga.it_video',
            kodami_video: 'kodami.it_video',
            geopop_video: 'geopop.it_video',
            wamily_video: 'fanpage.it_video',
            lexplain_video: 'fanpage.it_video',
        },
        placementId: {
            fanpage_inarticle: 35179082,
            cookist_it_inarticle: 35282059,
            geopop_inarticle: 35281646,
            ckmobile_300x250: 12680661,
            ckmobile_300x250_bottom: 12680662,
            ckmobile_300x250_top: 24485986,
            ckmobile_fplayer: 12680663,
            ckmobile_leaderboard: 12680664,
            cookist_mobile_300x250_bottom: 12680672,
            cookist_mobile_300x250: 12680671,
            cookist_mobile_leaderboard: 12680673,
            ck_it_mobile_300x250: 17835634,
            ck_it_mobile_300x250_bottom: 17835635,
            ck_it_mobile_300x250_top: 17835633,
            ck_it_mobile_fplayer: 17835636,
            ck_it_mobile_leadeboard: 17835639,
            cookist_it_mobile_300x250: 17835640,
            cookist_it_mobile_300x250_bottom: 17835642,
            cookist_it_mobile_leaderboard: 17835643,
            fpmobile_300x250: 12680682,
            fpmobile_300x250_bottom: 12680683,
            fpmobile_300x250_top: 16638781,
            fpmobile_fplayer: 12680684,
            fpmobile_leadeboard: 12680685,
            geopop_bottom: 22777855,
            geopop_fplayer: 22777856,
            geopop_leaderboard: 22777853,
            geopop_middle: 22777854,
            geopop_top: 22777849,
            //kodami_overlayer:35463873,
            kodami_bottom: 20791657,
            kodami_header: 20791624,
            kodami_low: 20791653,
            kodami_middle: 20791644,
            kodami_top: 20791626,
            Lexplain_bottom: 30100306,
            Lexplain_fplayer: 30100304,
            Lexplain_leaderboard: 30100305,
            Lexplain_middle: 30100303,
            Lexplain_top: 30088229,
            ohga_300x250_middle: 14194519,
            ohga_300x250_top: 14194517,
            ohga_bottom: 18288318,
            ohga_header: 14194515,
            ohga_low: 24485693,
            fanpage_video: 12957535,
            ck_it_video: 17835664,
            geopop_video: 22777858,
            ck_wow_video: 13108461,
            ohga_video: 14194524,
            kodami_video: 20791665,
            wamily_video: 12957535,
            lexplain_video: 12957535
        }
    },
    mobkoi: {
        display: {
            ck_it_mobile_fplayer: {
                placementId: 'F5FFF769',
                gpid: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_fplayer2: {
                placementId: 'A58DC887',
                gpid: '/1010633/ck_it_mobile_fplayer2'
            },
            ck_it_mobile_fplayer3: {
                placementId: 'A58DC887',
                gpid: '/1010633/ck_it_mobile_fplayer3'
            },
            ck_it_mobile_fplayer4: {
                placementId: 'F5FFF769',
                gpid: '/1010633/ck_it_mobile_fplayer4'
            },
            ck_it_mobile_300x250: {
                placementId: 'A58DC887',
                gpid: '/1010633/ck_it_mobile_300x250'
            },
            ck_it_mobile_300x250_bottom: {
                placementId: 'A58DC887',
                gpid: '/1010633/ck_it_mobile_300x250_bottom'
            },
            ck_it_mobile_300x250_top: {
                placementId: 'F5FFF769',
                gpid: '/1010633/ck_it_mobile_300x250_top'
            },
            cookist_it_inarticle: {
                placementId: 'A58DC887',
                gpid: '/1010633/cookist_it_inarticle'
            },
            ckmobile_300x250: {
                placementId: 'F1C6C071',
                gpid: '/1010633/ckmobile_300x250'
            },
            ckmobile_300x250_top: {
                placementId: 'F93D37A2',
                gpid: '/1010633/ckmobile_300x250_top'
            },
            ckmobile_300x250_bottom: {
                placementId: 'F93D37A2',
                gpid: '/1010633/ckmobile_300x250_bottom'
            },
            ckmobile_fplayer: {
                placementId: 'F93D37A2',
                gpid: '/1010633/ckmobile_fplayer'
            },
            geopop_middle: {
                placementId: 'B3DCAABC',
                gpid: '/1010633/geopop_middle'
            },
            geopop_bottom: {
                placementId: 'B3DCAABC',
                gpid: '/1010633/geopop_bottom'
            },
            geopop_fplayer: {
                placementId: 'F93D37A2',
                gpid: '/1010633/geopop_fplayer'
            },
            ckmobile_fplayer2: {
                placementId: 'A52D20ED',
                gpid: '/1010633/ckmobile_fplayer2'
            },
            ckmobile_fplayer3: {
                placementId: 'A52D20ED',
                gpid: '/1010633/ckmobile_fplayer3'
            },
            ckmobile_fplayer4: {
                placementId: 'B3DCAABC',
                gpid: '/1010633/ckmobile_fplayer4'
            },
            geopop_top: {
                placementId: 'B3DCAABC',
                gpid: '/1010633/geopop_top'
            },
            geopop_inarticle: {
                placementId: 'B3DCAABC',
                gpid: '/1010633/geopop_inarticle'
            },
            fanpage_inarticle: {
                placementId: 'DEFA3CDA',
                gpid: '/1010633/fanpage_inarticle'
            },
            fpmobile_300x250: {
                placementId: 'DEFA3CDA',
                gpid: '/1010633/fpmobile_300x250'
            },
            fpmobile_300x250_top: {
                placementId: 'C680A2D5',
                gpid: '/1010633/fpmobile_300x250_top'
            },
            fpmobile_300x250_bottom: {
                placementId: 'C680A2D5',
                gpid: '/1010633/fpmobile_300x250_bottom'
            },
            fpmobile_fplayer: {
                placementId: 'C680A2D5',
                gpid: '/1010633/fpmobile_fplayer'
            },
            kodami_middle: {
                placementId: 'F8D3D235',
                gpid: '/1010633/kodami_middle'
            },
            kodami_bottom: {
                placementId: 'F8D3D235',
                gpid: '/1010633/kodami_bottom'
            },
            kodami_inarticle: {
                placementId: 'E3FA868D',
                gpid: '/1010633/kodami_inarticle'
            },
            kodami_low: {
                placementId: 'E3FA868D',
                gpid: '/1010633/kodami_low'
            },
            kodami_top: {
                placementId: 'E3FA868D',
                gpid: '/1010633/kodami_top'
            },
        },
    },
    taboola: {
        display: {
            //kodami_overlayer: {
            //    publisherId: '1816501',
            //},
            fpmobile_300x250: {
                publisherId: '1816501',
            },
            fpmobile_300x250_top: {
                publisherId: '1816501',
            },
            fpmobile_leadeboard: {
                publisherId: '1816501',
            },
            //inarticle
            fanpage_inarticle: {
                publisherId: '1816501',
            },
            cookist_it_inarticle: {
                publisherId: '1816509',
            },
            geopop_inarticle: {
                publisherId: '1816505',
            },
            fpmobile_fplayer: {
                publisherId: '1816501',
            },
            fpmobile_fplayer2: {
                publisherId: '1816501',
            },
            fpmobile_fplayer3: {
                publisherId: '1816501',
            },
            fpmobile_fplayer4: {
                publisherId: '1816501',
            },
            ck_it_mobile_fplayer2: {
                publisherId: '1816509',
            },
            ck_it_mobile_fplayer3: {
                publisherId: '1816509',
            },
            ck_it_mobile_fplayer4: {
                publisherId: '1816509',
            },
            ck_it_mobile_300x250_bottom: {
                publisherId: '1816509',
            },
            geopop_fplayer: {
                publisherId: '1816505',
            },
            geopop_fplayer2: {
                publisherId: '1816505',
            },
            geopop_fplayer3: {
                publisherId: '1816505',
            },
            geopop_fplayer4: {
                publisherId: '1816505',
            },
            geopop_bottom: {
                publisherId: '1816505',
            },
            ckmobile_300x250: {
                publisherId: '1816509',
            },
            ckmobile_300x250_bottom: {
                publisherId: '1816509',
            },
            ckmobile_300x250_top: {
                publisherId: '1816509',
            },
            ckmobile_fplayer: {
                publisherId: '1838467',
            },
            ckmobile_leaderboard: {
                publisherId: '1838467',
            },
            cookist_mobile_300x250_bottom: {
                publisherId: '1838467',
            },
            cookist_mobile_300x250: {
                publisherId: '1838467',
            },
            cookist_mobile_leaderboard: {
                publisherId: '1838467',
            },
            ck_it_mobile_300x250: {
                publisherId: '1816509',
            },
            ck_it_mobile_300x250_top: {
                publisherId: '1816509',
            },
            ck_it_mobile_fplayer: {
                publisherId: '1816509',
            },
            ck_it_mobile_leadeboard: {
                publisherId: '1816509',
            },
            cookist_it_mobile_300x250: {
                publisherId: '1816509',
            },
            cookist_it_mobile_300x250_bottom: {
                publisherId: '1816509',
            },
            cookist_it_mobile_leaderboard: {
                publisherId: '1816509',
            },
            geopop_leaderboard: {
                publisherId: '1816505',
            },
            geopop_middle: {
                publisherId: '1816505',
            },
            geopop_top: {
                publisherId: '1816505',
            },
        }
    },
    improve: {
        video: {
            fanpage_video: {
                placementId: 23319251,
                publisherId: 1993
            },
            ck_it_video: {
                placementId: 23319278,
                publisherId: 1993
            },
            ck_wow_video: {
                placementId: 23319278,
                publisherId: 1993
            },
            ck_legal_video: {
                placementId: 23319278,
                publisherId: 1993
            },
            geopop_video: {
                placementId: 23319279,
                publisherId: 1993
            },
        }
    },
    rubicon: {
        display: {
            //inarticle
            fanpage_inarticle: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            cookist_it_inarticle: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724776,
            },
            geopop_inarticle: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            //  fanpage
            fpmobile_leadeboard: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            fpmobile_300x250_top: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            fpmobile_300x250: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            fpmobile_fplayer: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            fpmobile_300x250_bottom: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            //  cookstit
            ck_it_mobile_leadeboard: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724776,
            },
            ck_it_mobile_300x250_top: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724776,
            },
            ck_it_mobile_300x250: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724776,
            },
            ck_it_mobile_fplayer: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724776,
            },
            ck_it_mobile_fplayer2: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724776,
            },
            ck_it_mobile_fplayer3: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724776,
            },
            ck_it_mobile_fplayer4: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724776,
            },
            ck_it_mobile_300x250_bottom: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724776,
            },
            //  Ohga
            ohga_header: {
                accountId: 12546,
                siteId: 584384,
                zoneId: 3724802,
            },
            ohga_300x250_top: {
                accountId: 12546,
                siteId: 584384,
                zoneId: 3724802,
            },
            ohga_300x250_middle: {
                accountId: 12546,
                siteId: 584384,
                zoneId: 3724802,
            },
            ohga_low: {
                accountId: 12546,
                siteId: 584384,
                zoneId: 3724802,
            },
            ohga_bottom: {
                accountId: 12546,
                siteId: 584384,
                zoneId: 3724802,
            },
            //  Geopop
            geopop_leaderboard: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            geopop_top: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            geopop_middle: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            geopop_fplayer: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            geopop_fplayer2: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            geopop_fplayer3: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            geopop_fplayer4: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            geopop_bottom: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            //  cookistcom
            ckmobile_leaderboard: {
                accountId: 12546,
                siteId: 584386,
                zoneId: 3724794,
            },
            ckmobile_300x250_top: {
                accountId: 12546,
                siteId: 584386,
                zoneId: 3724794,
            },
            ckmobile_300x250: {
                accountId: 12546,
                siteId: 584386,
                zoneId: 3724794,
            },
            ckmobile_fplayer: {
                accountId: 12546,
                siteId: 584386,
                zoneId: 3724794,
            },
            ckmobile_300x250_bottom: {
                accountId: 12546,
                siteId: 584386,
                zoneId: 3724794,
            },
            //  Kodami
            //kodami_overlayer: {
            //    accountId: 12546,
            //    siteId: 583266,
            //    zoneId: 3724770,
            //},
            kodami_header: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            kodami_top: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            kodami_middle: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            kodami_low: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
            kodami_bottom: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724770,
            },
        },
        video: {
            fanpage_video: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724772,
            },
            ck_it_video: {
                accountId: 12546,
                siteId: 584380,
                zoneId: 3724778,
            },
            ck_wow_video: {
                accountId: 12546,
                siteId: 584386,
                zoneId: 3724796,
            },
            ck_legal_video: {
                accountId: 12546,
                siteId: 584386,
                zoneId: 3724796,
            },
            ohga_video: {
                accountId: 12546,
                siteId: 584384,
                zoneId: 3724804,
            },
            kodami_video: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724772,
            },
            geopop_video: {
                accountId: 12546,
                siteId: 584382,
                zoneId: 3724784,
            },
            wamily_video: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724772,
            },
            lexplain_video: {
                accountId: 12546,
                siteId: 583266,
                zoneId: 3724772,
            },
        }
    },
    pubmatic_apex: {
        display: {
            //  fanpage
            fpmobile_leadeboard: {
                publisherId: '161546',
                adSlot: '6739111',
            },
            fpmobile_300x250_top: {
                publisherId: '161546',
                adSlot: '6739112',
            },
            fpmobile_300x250: {
                publisherId: '161546',
                adSlot: '6739113',
            },
            fpmobile_fplayer: {
                publisherId: '161546',
                adSlot: '6739114',
            },
            fpmobile_300x250_bottom: {
                publisherId: '161546',
                adSlot: '6739115',
            },
            //  cookstit
            ck_it_mobile_leadeboard: {
                publisherId: '161546',
                adSlot: '6739116',
            },
            ck_it_mobile_300x250_top: {
                publisherId: '161546',
                adSlot: '6739117',
            },
            ck_it_mobile_300x250: {
                publisherId: '161546',
                adSlot: '6739118',
            },
            ck_it_mobile_fplayer: {
                publisherId: '161546',
                adSlot: '6739119',
            },
            ck_it_mobile_fplayer2: {
                publisherId: '161546',
                adSlot: '6739120',
            },
            ck_it_mobile_fplayer3: {
                publisherId: '161546',
                adSlot: '6739121',
            },
            ck_it_mobile_fplayer4: {
                publisherId: '161546',
                adSlot: '6739122',
            },
            ck_it_mobile_300x250_bottom: {
                publisherId: '161546',
                adSlot: '6739123',
            },
            //  Ohga
            ohga_header: {
                publisherId: '161546',
                adSlot: '6739124',
            },
            ohga_300x250_top: {
                publisherId: '161546',
                adSlot: '6739125',
            },
            ohga_300x250_middle: {
                publisherId: '161546',
                adSlot: '6739126',
            },
            ohga_low: {
                publisherId: '161546',
                adSlot: '6739127',
            },
            ohga_bottom: {
                publisherId: '161546',
                adSlot: '6739128',
            },
            //  Geopop
            geopop_leaderboard: {
                publisherId: '161546',
                adSlot: '6739129',
            },
            geopop_top: {
                publisherId: '161546',
                adSlot: '6739130',
            },
            geopop_middle: {
                publisherId: '161546',
                adSlot: '6739131',
            },
            geopop_fplayer: {
                publisherId: '161546',
                adSlot: '6739132',
            },
            geopop_fplayer2: {
                publisherId: '161546',
                adSlot: '6739133',
            },
            geopop_fplayer3: {
                publisherId: '161546',
                adSlot: '6739134',
            },
            geopop_fplayer4: {
                publisherId: '161546',
                adSlot: '6739135',
            },
            geopop_bottom: {
                publisherId: '161546',
                adSlot: '6739136',
            },
            //  cookistcom
            ckmobile_leaderboard: {
                publisherId: '161546',
                adSlot: '6739137',
            },
            ckmobile_300x250_top: {
                publisherId: '161546',
                adSlot: '6739138',
            },
            ckmobile_300x250: {
                publisherId: '161546',
                adSlot: '6739139',
            },
            ckmobile_fplayer: {
                publisherId: '161546',
                adSlot: '6739140',
            },
            ckmobile_300x250_bottom: {
                publisherId: '161546',
                adSlot: '6739141',
            },
            //  Kodami
            kodami_header: {
                publisherId: '161546',
                adSlot: '6739142',
            },
            kodami_top: {
                publisherId: '161546',
                adSlot: '6739143',
            },
            kodami_middle: {
                publisherId: '161546',
                adSlot: '6739144',
            },
            kodami_low: {
                publisherId: '161546',
                adSlot: '6739145',
            },
            kodami_bottom: {
                publisherId: '161546',
                adSlot: '6739146    ',
            },
        },
        video: {
            fanpage_video: {
                publisherId: '161546',
                adSlot: '6739147',
            },
            ck_it_video: {
                publisherId: '161546',
                adSlot: '6739150',
            },
            ck_wow_video: {
                publisherId: '161546',
                adSlot: '6739158',
            },
            ck_legal_video: {
                publisherId: '161546',
                adSlot: '6739147',
            },
            ohga_video: {
                publisherId: '161546',
                adSlot: '6739153',
            },
            kodami_video: {
                publisherId: '161546',
                adSlot: '6739161',
            },
            geopop_video: {
                publisherId: '161546',
                adSlot: '6739155',
            },
            wamily_video: {
                publisherId: '161546',
                adSlot: '6739147',
            },
            lexplain_video: {
                publisherId: '161546',
                adSlot: '6739147',
            },
        }
    },
    criteo: {
        display: {
            //  Kodami
            kodami_header: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/kodami_header',
                pbadslot: '/1010633/kodami_header'
            },
            kodami_top: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/kodami_top',
                pbadslot: '/1010633/kodami_top'
            },
            kodami_middle: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/kodami_middle',
                pbadslot: '/1010633/kodami_middle'
            },
            kodami_low: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/kodami_low',
                pbadslot: '/1010633/kodami_low'
            },
            kodami_bottom: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/kodami_bottom',
                pbadslot: '/1010633/kodami_bottom'
            },
            //fanpage
            fpmobile_300x250: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/fpmobile_300x250',
                pbadslot: '/1010633/fpmobile_300x250'
            },
            fpmobile_300x250_top: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/fpmobile_300x250_top',
                pbadslot: '/1010633/fpmobile_300x250_top'
            },
            fpmobile_leadeboard: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/fpmobile_leadeboard',
                pbadslot: '/1010633/fpmobile_leadeboard'
            },
            fpmobile_fplayer: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/fpmobile_fplayer',
                pbadslot: '/1010633/fpmobile_fplayer'
            },
            fpmobile_300x250_bottom: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/fpmobile_300x250_bottom',
                pbadslot: '/1010633/fpmobile_300x250_bottom'
            },
            //cookistit
            ck_it_mobile_300x250: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ck_it_mobile_300x250',
                pbadslot: '/1010633/ck_it_mobile_300x250'
            },
            ck_it_mobile_300x250_top: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ck_it_mobile_300x250_top',
                pbadslot: '/1010633/ck_it_mobile_300x250_top'
            },
            ck_it_mobile_fplayer: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ck_it_mobile_fplayer',
                pbadslot: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_leadeboard: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ck_it_mobile_leadeboard',
                pbadslot: '/1010633/ck_it_mobile_leadeboard'
            },
            ck_it_mobile_fplayer2: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ck_it_mobile_fplayer',
                pbadslot: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_fplayer3: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ck_it_mobile_fplayer',
                pbadslot: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_fplayer4: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ck_it_mobile_fplayer',
                pbadslot: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_300x250_bottom: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ck_it_mobile_300x250_bottom',
                pbadslot: '/1010633/ck_it_mobile_300x250_bottom'
            },
            cookist_it_mobile_300x250: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/cookist_it_mobile_300x250',
                pbadslot: '/1010633/cookist_it_mobile_300x250'
            },
            cookist_it_mobile_300x250_bottom: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/cookist_it_mobile_300x250_bottom',
                pbadslot: '/1010633/cookist_it_mobile_300x250_bottom'
            },
            cookist_it_mobile_leaderboard: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ck_it_mobile_leadeboard',
                pbadslot: '/1010633/ck_it_mobile_leadeboard'
            },
            //geopop
            geopop_leaderboard: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/geopop_leaderboard',
                pbadslot: '/1010633/geopop_leaderboard'
            },
            geopop_middle: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/geopop_middle',
                pbadslot: '/1010633/geopop_middle'
            },
            geopop_top: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/geopop_top',
                pbadslot: '/1010633/geopop_top'
            },
            geopop_fplayer: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/geopop_fplayer',
                pbadslot: '/1010633/geopop_fplayer'
            },
            geopop_fplayer2: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/geopop_fplayer/geopop_fplayer2',
                pbadslot: '/1010633/geopop_fplayer/geopop_fplayer2'
            },
            geopop_fplayer3: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/geopop_fplayer/geopop_fplayer3',
                pbadslot: '/1010633/geopop_fplayer/geopop_fplayer3'
            },
            geopop_fplayer4: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/geopop_fplayer/geopop_fplayer4',
                pbadslot: '/1010633/geopop_fplayer/geopop_fplayer4'
            },
            geopop_bottom: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/geopop_bottom',
                pbadslot: '/1010633/geopop_bottom'
            },
            //cookistcom
            ckmobile_300x250: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ckmobile_300x250',
                pbadslot: '/1010633/ckmobile_300x250'
            },
            ckmobile_300x250_bottom: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ckmobile_300x250_bottom',
                pbadslot: '/1010633/ckmobile_300x250_bottom'
            },
            ckmobile_300x250_top: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ckmobile_300x250_top',
                pbadslot: '/1010633/ckmobile_300x250_top'
            },
            ckmobile_fplayer: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ckmobile_fplayer',
                pbadslot: '/1010633/ckmobile_fplayer'
            },
        },
        video: {
            fanpage_video: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/fanpage/video',
                pbadslot: '/1010633/fanpage/video'
            },
            ck_it_video: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/cookistit/video',
                pbadslot: '/1010633/cookistit/video'
            },
            ck_wow_video: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/cookistcom/video',
                pbadslot: '/1010633/cookistcom/video'
            },
            ck_legal_video: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/cookistlegal/video',
                pbadslot: '/1010633/cookistlegal/video'
            },
            ohga_video: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/ohga/video',
                pbadslot: '/1010633/ohga/video'
            },
            kodami_video: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/kodami/video',
                pbadslot: '/1010633/kodami/video'
            },
            geopop_video: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/geopop/video',
                pbadslot: '/1010633/geopop/video'
            },
            wamily_video: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/wamily/video',
                pbadslot: '/1010633/wamily/video'
            },
            lexplain_video: {
                siteId: '105066',
                networkId: 1974,
                gpid: '/1010633/lexplain/video',
                pbadslot: '/1010633/lexplain/video'
            },
        }
    },
    ix: {
        display: {
            //  Kodami
            kodami_header: {
                siteId: '1106633',
                gpid: '/1010633/kodami_header' //tu che leggi ti chiederai "a che cazz serv?": serve.
            },
            kodami_top: {
                siteId: '1106631',
                gpid: '/1010633/kodami_top'
            },
            kodami_middle: {
                siteId: '1106632',
                gpid: '/1010633/kodami_middle'
            },
            kodami_low: {
                siteId: '1106634',
                gpid: '/1010633/kodami_low'
            },
            kodami_bottom: {
                siteId: '1106635',
                gpid: '/1010633/kodami_bottom'
            },
            //fanpage
            fpmobile_300x250: {
                siteId: '1106608',
                gpid: '/1010633/fpmobile_300x250'
            },
            fpmobile_300x250_top: {
                siteId: '1106607',
                gpid: '/1010633/fpmobile_300x250_top'
            },
            fpmobile_leadeboard: {
                siteId: '1106609',
                gpid: '/1010633/fpmobile_leadeboard'
            },
            fpmobile_fplayer: {
                siteId: '1106610',
                gpid: '/1010633/fpmobile_fplayer'
            },
            fpmobile_300x250_bottom: {
                siteId: '1106611',
                gpid: '/1010633/fpmobile_300x250_bottom'
            },
            //cookistit
            ck_it_mobile_300x250: {
                siteId: '1106614',
                gpid: '/1010633/ck_it_mobile_300x250'
            },
            ck_it_mobile_300x250_top: {
                siteId: '1106613',
                gpid: '/1010633/ck_it_mobile_300x250_top'
            },
            ck_it_mobile_fplayer: {
                siteId: '1106616',
                gpid: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_leadeboard: {
                siteId: '1106615',
                gpid: '/1010633/ck_it_mobile_leadeboard'
            },
            ck_it_mobile_fplayer2: {
                siteId: '1106615',
                gpid: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_fplayer3: {
                siteId: '1106615',
                gpid: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_fplayer4: {
                siteId: '1106615',
                gpid: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_300x250_bottom: {
                siteId: '1106617',
                gpid: '/1010633/ck_it_mobile_300x250_bottom'
            },
            cookist_it_mobile_300x250: {
                siteId: '1195754',
                gpid: '/1010633/cookist_it_mobile_300x250'
            },
            cookist_it_mobile_300x250_bottom: {
                siteId: '1195756',
                gpid: '/1010633/cookist_it_mobile_300x250_bottom'
            },
            cookist_it_mobile_leaderboard: {
                siteId: '1195757',
                gpid: '/1010633/ck_it_mobile_leadeboard'
            },
            //geopop
            geopop_leaderboard: {
                siteId: '1047800',
                gpid: '/1010633/geopop_leaderboard'
            },
            geopop_middle: {
                siteId: '1047798',
                gpid: '/1010633/geopop_middle'
            },
            geopop_top: {
                siteId: '1047797',
                gpid: '/1010633/geopop_top'
            },
            geopop_fplayer: {
                siteId: '1047799',
                gpid: '/1010633/geopop_fplayer'
            },
            geopop_fplayer2: {
                siteId: '1047799',
                gpid: '/1010633/geopop_fplayer/geopop_fplayer2'
            },
            geopop_fplayer3: {
                siteId: '1047799',
                gpid: '/1010633/geopop_fplayer/geopop_fplayer3'
            },
            geopop_fplayer4: {
                siteId: '1047799',
                gpid: '/1010633/geopop_fplayer/geopop_fplayer4'
            },
            geopop_bottom: {
                siteId: '1047801',
                gpid: '/1010633/geopop_bottom'
            },
            //cookistcom
            ckmobile_300x250: {
                siteId: '1047801',
                gpid: '/1010633/ckmobile_300x250'
            },
            ckmobile_300x250_bottom: {
                siteId: '1047801',
                gpid: '/1010633/ckmobile_300x250_bottom'
            },
            ckmobile_300x250_top: {
                siteId: '1047801',
                gpid: '/1010633/ckmobile_300x250_top'
            },
            ckmobile_fplayer: {
                siteId: '1047801',
                gpid: '/1010633/ckmobile_fplayer'
            },
        },
        video: {
            fanpage_video: {
                siteId: '1106612',
                gpid: '/1010633/fanpage/video'
            },
            ck_it_video: {
                siteId: '1106618',
                gpid: '/1010633/cookistit/video'
            },
            ck_wow_video: {
                siteId: '1106624',
                gpid: '/1010633/cookistcom/video'
            },
            ck_legal_video: {
                siteId: '1106624',
                gpid: '/1010633/cookistlegal/video'
            },
            ohga_video: {
                siteId: '1106630',
                gpid: '/1010633/ohga/video'
            },
            kodami_video: {
                siteId: '1106636',
                gpid: '/1010633/kodami/video'
            },
            geopop_video: {
                siteId: '1047802',
                gpid: '/1010633/geopop/video'
            },
            wamily_video: {
                siteId: '1106612',
                gpid: '/1010633/wamily/video'
            },
            lexplain_video: {
                siteId: '1047808',
                gpid: '/1010633/lexplain/video'
            },
        }
    }, seedtag: {
        display: {
            // Kodami
            kodami_header: {
                publisherId: '8274-3016-01',
                adUnitId: '35406507',
                placement: 'inBanner',
                gpid: '/1010633/kodami_header'
            },
            kodami_top: {
                publisherId: '8274-3016-01',
                adUnitId: '35406643',
                placement: 'inArticle',
                gpid: '/1010633/kodami_top'
            },
            kodami_middle: {
                publisherId: '8274-3016-01',
                adUnitId: '35406642',
                placement: 'inArticle',
                gpid: '/1010633/kodami_middle'
            },
            kodami_low: {
                publisherId: '8274-3016-01',
                adUnitId: '35406641',
                placement: 'inArticle',
                gpid: '/1010633/kodami_low'
            },
            kodami_bottom: {
                publisherId: '8274-3016-01',
                adUnitId: '35406506',
                placement: 'inArticle',
                gpid: '/1010633/kodami_bottom'
            },
            // fanpage
            fpmobile_300x250: {
                publisherId: '1044-6008-01',
                adUnitId: '35406650',
                placement: 'inArticle',
                gpid: '/1010633/fpmobile_300x250'
            },
            fpmobile_300x250_top: {
                publisherId: '1044-6008-01',
                adUnitId: '35406651',
                placement: 'inBanner',
                gpid: '/1010633/fpmobile_300x250_top'
            },
            fpmobile_leadeboard: {
                publisherId: '1044-6008-01',
                adUnitId: '35406441',
                placement: 'inBanner',
                gpid: '/1010633/fpmobile_leadeboard'
            },
            fpmobile_fplayer: {
                publisherId: '1044-6008-01',
                adUnitId: '35406652',
                placement: 'inBanner',
                gpid: '/1010633/fpmobile_fplayer'
            },
            fpmobile_300x250_bottom: {
                publisherId: '1044-6008-01',
                adUnitId: '35406440',
                placement: 'inBanner',
                gpid: '/1010633/fpmobile_300x250_bottom'
            },
            // cookistit
            ck_it_mobile_300x250: {
                publisherId: '3396-5388-01',
                adUnitId: '35406635',
                placement: 'inArticle',
                gpid: '/1010633/ck_it_mobile_300x250'
            },
            ck_it_mobile_300x250_top: {
                publisherId: '3396-5388-01',
                adUnitId: '35406636',
                placement: 'inBanner',
                gpid: '/1010633/ck_it_mobile_300x250_top'
            },
            ck_it_mobile_fplayer: {
                publisherId: '3396-5388-01',
                adUnitId: '35406637',
                placement: 'inBanner',
                gpid: '/1010633/ck_it_mobile_fplayer'
            },
            ck_it_mobile_leadeboard: {
                publisherId: '3396-5388-01',
                adUnitId: '35406470',
                placement: 'inBanner',
                gpid: '/1010633/ck_it_mobile_leadeboard'
            },
            ck_it_mobile_fplayer2: {
                publisherId: '3396-5388-01',
                adUnitId: '35406470',
                placement: 'inBanner',
                gpid: '/1010633/ck_it_mobile_fplayer2'
            },
            ck_it_mobile_fplayer3: {
                publisherId: '3396-5388-01',
                adUnitId: '35406470',
                placement: 'inBanner',
                gpid: '/1010633/ck_it_mobile_fplayer3'
            },
            ck_it_mobile_fplayer4: {
                publisherId: '3396-5388-01',
                adUnitId: '35406470',
                placement: 'inBanner',
                gpid: '/1010633/ck_it_mobile_fplayer4'
            },
            ck_it_mobile_300x250_bottom: {
                publisherId: '3396-5388-01',
                adUnitId: '35406469',
                placement: 'inBanner',
                gpid: '/1010633/ck_it_mobile_300x250_bottom'
            },
            cookist_it_mobile_300x250: {
                publisherId: '3396-5388-01',
                adUnitId: '35406635',
                placement: 'inArticle',
                gpid: '/1010633/cookist_it_mobile_300x250'
            },
            cookist_it_mobile_300x250_bottom: {
                publisherId: '3396-5388-01',
                adUnitId: '35406469',
                placement: 'inBanner',
                gpid: '/1010633/cookist_it_mobile_300x250_bottom'
            },
            cookist_it_mobile_leaderboard: {
                publisherId: '3396-5388-01',
                adUnitId: '35406470',
                placement: 'inBanner',
                gpid: '/1010633/cookist_it_mobile_leaderboard'
            },
            // geopop
            geopop_leaderboard: {
                publisherId: '2008-0806-01',
                adUnitId: '35406645',
                placement: 'inBanner',
                gpid: '/1010633/geopop_leaderboard'
            },
            geopop_middle: {
                publisherId: '2008-0806-01',
                adUnitId: '35406647',
                placement: 'inBanner',
                gpid: '/1010633/geopop_middle'
            },
            geopop_top: {
                publisherId: '2008-0806-01',
                adUnitId: '35406648',
                placement: 'inBanner',
                gpid: '/1010633/geopop_top'
            },
            geopop_fplayer: {
                publisherId: '2008-0806-01',
                adUnitId: '35406646',
                placement: 'inArticle',
                gpid: '/1010633/geopop_fplayer'
            },
            geopop_fplayer2: {
                publisherId: '2008-0806-01',
                adUnitId: '35406646',
                placement: 'inArticle',
                gpid: '/1010633/geopop_fplayer2'
            },
            geopop_fplayer3: {
                publisherId: '2008-0806-01',
                adUnitId: '35406646',
                placement: 'inArticle',
                gpid: '/1010633/geopop_fplayer3'
            },
            geopop_fplayer4: {
                publisherId: '2008-0806-01',
                adUnitId: '35406646',
                placement: 'inArticle',
                gpid: '/1010633/geopop_fplayer4'
            },
            geopop_bottom: {
                publisherId: '2008-0806-01',
                adUnitId: '35406644',
                placement: 'inBanner',
                gpid: '/1010633/geopop_bottom'
            },
            // cookistcom
            ckmobile_300x250: {
                publisherId: '4258-6544-01',
                adUnitId: '35406626',
                placement: 'inArticle',
                gpid: '/1010633/ckmobile_300x250'
            },
            ckmobile_300x250_bottom: {
                publisherId: '4258-6544-01',
                adUnitId: '35406630',
                placement: 'inBanner',
                gpid: '/1010633/ckmobile_300x250_bottom'
            },
            ckmobile_300x250_top: {
                publisherId: '4258-6544-01',
                adUnitId: '35406628',
                placement: 'inArticle',
                gpid: '/1010633/ckmobile_300x250_top'
            },
            ckmobile_fplayer: {
                publisherId: '4258-6544-01',
                adUnitId: '35406629',
                placement: 'inArticle',
                gpid: '/1010633/ckmobile_fplayer'
            },
        },
        video: {
            fanpage_video: {
                publisherId: '1044-6008-01',
                adUnitId: '35406438',
                placement: 'inStream',
                gpid: '/1010633/fanpage_video'
            },
            ck_it_video: {
                publisherId: '3396-5388-01',
                adUnitId: '35406608',
                placement: 'inStream',
                gpid: '/1010633/ck_it_video'
            },
            ck_wow_video: {
                publisherId: '4258-6544-01',
                adUnitId: '35406601',
                placement: 'inStream',
                gpid: '/1010633/ck_wow_video'
            },
            ck_legal_video: {
                publisherId: '4258-6544-01',
                adUnitId: '35406601',
                placement: 'inStream',
                gpid: '/1010633/ck_legal_video'
            },
            ohga_video: {
                publisherId: '1044-6008-01',
                adUnitId: '35406438',
                placement: 'inStream',
                gpid: '/1010633/ohga_video'
            },
            kodami_video: {
                publisherId: '8274-3016-01',
                adUnitId: '35406527',
                placement: 'inStream',
                gpid: '/1010633/kodami_video'
            },
            geopop_video: {
                publisherId: '2008-0806-01',
                adUnitId: '35406523',
                placement: 'inStream',
                gpid: '/1010633/geopop_video'
            },
            wamily_video: {
                publisherId: '1044-6008-01',
                adUnitId: '35406438',
                placement: 'inStream',
                gpid: '/1010633/wamily_video'
            },
            lexplain_video: {
                publisherId: '1044-6008-01',
                adUnitId: '35406438',
                placement: 'inStream',
                gpid: '/1010633/lexplain_video'
            }
        }
    },
    pubmatic: {
        display: {
            //  inarticle
            fanpage_inarticle: {
                publisherId: '161182',
                adSlot: '6787215',
            },
            cookist_it_inarticle: {
                publisherId: '161182',
                adSlot: '6787250',
            },
            geopop_inarticle: {
                publisherId: '161182',
                adSlot: '6787275',
            },
            //  fanpage
            fpmobile_leadeboard: {
                publisherId: '161182',
                adSlot: '6629965',
            },
            fpmobile_300x250_top: {
                publisherId: '161182',
                adSlot: '6629966',
            },
            fpmobile_300x250: {
                publisherId: '161182',
                adSlot: '6629967',
            },
            fpmobile_fplayer: {
                publisherId: '161182',
                adSlot: '6629968',
            },
            fpmobile_300x250_bottom: {
                publisherId: '161182',
                adSlot: '6629969',
            },
            //  cookstit
            ck_it_mobile_leadeboard: {
                publisherId: '161182',
                adSlot: '6629970',
            },
            ck_it_mobile_300x250_top: {
                publisherId: '161182',
                adSlot: '6629971',
            },
            ck_it_mobile_300x250: {
                publisherId: '161182',
                adSlot: '6629972',
            },
            ck_it_mobile_fplayer: {
                publisherId: '161182',
                adSlot: '6629973',
            },
            ck_it_mobile_fplayer2: {
                publisherId: '161182',
                adSlot: '6629974',
            },
            ck_it_mobile_fplayer3: {
                publisherId: '161182',
                adSlot: '6629975',
            },
            ck_it_mobile_fplayer4: {
                publisherId: '161182',
                adSlot: '6629976',
            },
            ck_it_mobile_300x250_bottom: {
                publisherId: '161182',
                adSlot: '6629977',
            },
            //  Ohga
            ohga_header: {
                publisherId: '161182',
                adSlot: '6629978',
            },
            ohga_300x250_top: {
                publisherId: '161182',
                adSlot: '6629979',
            },
            ohga_300x250_middle: {
                publisherId: '161182',
                adSlot: '6629980',
            },
            ohga_low: {
                publisherId: '161182',
                adSlot: '6629981',
            },
            ohga_bottom: {
                publisherId: '161182',
                adSlot: '6629982',
            },
            //  Geopop
            geopop_leaderboard: {
                publisherId: '161182',
                adSlot: '6629983',
            },
            geopop_top: {
                publisherId: '161182',
                adSlot: '6629984',
            },
            geopop_middle: {
                publisherId: '161182',
                adSlot: '6629985',
            },
            geopop_fplayer: {
                publisherId: '161182',
                adSlot: '6629986',
            },
            geopop_fplayer2: {
                publisherId: '161182',
                adSlot: '6629987',
            },
            geopop_fplayer3: {
                publisherId: '161182',
                adSlot: '6629988',
            },
            geopop_fplayer4: {
                publisherId: '161182',
                adSlot: '6629989',
            },
            geopop_bottom: {
                publisherId: '161182',
                adSlot: '6629990',
            },
            //  cookistcom
            ckmobile_leaderboard: {
                publisherId: '161182',
                adSlot: '6629991',
            },
            ckmobile_300x250_top: {
                publisherId: '161182',
                adSlot: '6629992',
            },
            ckmobile_300x250: {
                publisherId: '161182',
                adSlot: '6629993',
            },
            ckmobile_fplayer: {
                publisherId: '161182',
                adSlot: '6629994',
            },
            ckmobile_300x250_bottom: {
                publisherId: '161182',
                adSlot: '6629995',
            },
            //  Kodami
            kodami_header: {
                publisherId: '161182',
                adSlot: '6629996',
            },
            kodami_top: {
                publisherId: '161182',
                adSlot: '6629997',
            },
            kodami_middle: {
                publisherId: '161182',
                adSlot: '6629998',
            },
            kodami_low: {
                publisherId: '161182',
                adSlot: '6629999',
            },
            kodami_bottom: {
                publisherId: '161182',
                adSlot: '6630000',
            },
        },
        video: {
            fanpage_video: {
                publisherId: '161182',
                adSlot: '6790502',
            },
            ck_it_video: {
                publisherId: '161182',
                adSlot: '6790505',
            },
            ck_wow_video: {
                publisherId: '161182',
                adSlot: '6790513',
            },
            ck_legal_video: {
                publisherId: '161182',
                adSlot: '6790513',
            },
            ohga_video: {
                publisherId: '161182',
                adSlot: '6790508',
            },
            kodami_video: {
                publisherId: '161182',
                adSlot: '6790516',
            },
            geopop_video: {
                publisherId: '161182',
                adSlot: '6790510',
            },
            wamily_video: {
                publisherId: '161182',
                adSlot: '6790502',
            },
            lexplain_video: {
                publisherId: '161182',
                adSlot: '6790502',
            },
        }
    }
};
